module.exports = __webpack_public_path__ + "img/newspaper.3d1c2140.svg";